export const VIDEO_CATEGORIES = {
  1: 'Animation',
  2: 'Audio Podcast',
  3: 'Case Study',
  4: 'Corporate Video',
  5: 'Digital Advertising',
  6: 'Documentary',
  7: 'Event Video',
  8: 'Explainer / Demo',
  9: 'Photography',
  10: 'Interview',
  11: 'Livestream',
  12: 'Music Video',
  13: 'News / Editorial',
  14: 'Testimonial',
  15: 'TV Commercial',
  16: 'TV Show',
  17: 'VR / 360 Video',
  18: 'Written Article',
  19: 'Other',
};

export const VIDEO_CATEGORY_MODELS = Object.keys(VIDEO_CATEGORIES).map((id) => ({
  id,
  label: VIDEO_CATEGORIES[id],
}));
